import React from "react";
import { Trophy, ExternalLink, Star } from "lucide-react";

const GbetBanner = () => (
  <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded-xl overflow-hidden my-6" data-testid="gbet-banner">
    <div className="flex flex-col md:flex-row items-center gap-4 p-5 md:p-6">
      <div className="flex items-center gap-3 shrink-0">
        <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center">
          <Trophy className="h-6 w-6 text-white" />
        </div>
        <div>
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-3 w-3 fill-amber-400 text-amber-400" />)}
          </div>
          <p className="text-green-400 font-bold text-lg leading-tight">GbetPools.com</p>
        </div>
      </div>
      <div className="flex-1 text-center md:text-left">
        <p className="text-white font-bold text-base md:text-lg">Stake Your Pool Draws for Fastest Payout!</p>
        <p className="text-gray-400 text-sm mt-0.5">Play pool online. Turn your predictions into real wins on GbetPools.com</p>
      </div>
      <a
        href="https://gbetpools.com"
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3 rounded-full flex items-center gap-2 transition-colors text-sm"
        data-testid="gbet-link"
      >
        Play Now <ExternalLink className="h-4 w-4" />
      </a>
    </div>
  </div>
);

export default GbetBanner;
